module.exports = __webpack_public_path__ + "static/assets/56b3fbfbbafa4fdb3cfbb84703fd5c6c.png";